import { Link } from "react-router-dom";

const RegionalTrucking = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]" />
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Regional Trade / TIR
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              Pakistan’s geographic location makes it an ideal gateway for
              Central Asian trade and combined with Afghanistan, offers a cost
              effective and time efficient transit corridor, linking Central
              Asian Republics with global markets. Sensing the opportunity, TCS,
              carrying a commercial load of medicines, opened the Pak Afghan
              corridor in 2021 as a transit route for Uzbekistan, Kazakhstan,
              Tajikistan, Kyrgyzstan, and beyond.
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              We move cargo from ports of origin to Karachi by sea, and truck
              onwards to destinations in the Central Asian cluster and beyond.
              Our services include cargo pickup at origin, shipping, port and
              custom clearance, cross stuffing and border crossing solutions. We
              partner with marine freight forwarders for sea logistics and 3rd
              party vendors for trucking requirements, including ambient and
              temperature-controlled containers.
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              In 2018 TCS became the 1st recipient of the TIR license awarded by
              the Pakistan National Council of the International Chamber of
              Commerce and offers customers a choice between regular trucking
              and TIR - allows containers to pass without being checked by
              customs at border crossing points, as per the 1975 TIR UN
              convention.
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              The Pakistan Afghanistan corridor offers significant savings on
              cost and, more importantly, journey time as compared to bilateral
              and transit cargo movements through the traditional supply chain.
            </p>
            <div className=" mt-[1rem] w-[100%]">
              <div className="flex justify-left">
                <Link
                  to="/regional-trade"
                  className="flex justify-center text-center items-center h-9 mt-[2px] rounded-sm text-white bg-[#D40511] border border-[#F21E26] w-[10rem] rounded-md mt-[1rem] p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
                >
                  Find Out More
                </Link>
              </div>
            </div>
          </div>
          <div className="flex-1 flex flex-col justify-center sm:mt-[0rem] mt-[1rem]">
            <img
              src="/international-banner/tir2.jpg"
              alt=""
              className="rounded-md max-w-[100%]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegionalTrucking;
